import styled from 'styled-components';
import Link from '@decisiv/ui-components/lib/components/Link';

// Night palettes swap the KDS link states: an unread title reads like text and
// a visited one takes the palette accent. Light keeps the KDS defaults.
const CardTitle = styled(Link)`
  font-size: 22px !important;
  font-weight: 400 !important;

  html[data-theme]:not([data-theme='light']) && {
    &:link {
      color: var(--if-ink-1);
    }

    &:visited,
    &:visited svg [fill='currentColor'] {
      color: var(--if-accent);
      fill: var(--if-accent);
    }

    &:hover,
    &:hover svg [fill='currentColor'] {
      color: var(--if-accent-hover);
      fill: var(--if-accent-hover);
    }
  }
`;

export { CardTitle };
